import { IRole, Permission } from '@tickeat/permissions';

export type RoleFormValues = Partial<Omit<IRole, 'organization' | 'permissions'>> & {
  permissions: Record<string, boolean>;
};

export const transformRoleFormValuesToPayload = (values: RoleFormValues): Partial<IRole> => {
  return {
    name: values.name,
    permissions: Object.entries(values.permissions)
      .filter(([_, isChecked]) => isChecked)
      .map(([permission]) => permission.replace('_', '.') as Permission),
  };
};

export const transformToUpdatableFormRole = (role?: Partial<IRole>): RoleFormValues => {
  return {
    name: role?.name || '',
    permissions:
      (role?.permissions || []).reduce((acc, perm) => {
        const permission = perm.replace('.', '_');

        acc[permission] = true;
        return acc;
      }, {} as Record<string, boolean>) || {},
  };
};
